import { Instagram, Linkedin, Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer id="footer" className="footer" data-testid="footer-section">
      <div className="footer-content">
        <h2 className="footer-brand">INTERLUDE</h2>
        <p className="footer-tagline">Bespoke Fragrance Solutions for Hospitality</p>
        
        <nav className="footer-links">
          <a href="#story" className="footer-link" data-testid="footer-link-about">About</a>
          <a href="#collection" className="footer-link" data-testid="footer-link-fragrances">Fragrances</a>
          <a href="#partnership" className="footer-link" data-testid="footer-link-partnership">Partnership</a>
          <a href="mailto:partner@experienceinterlude.com" className="footer-link" data-testid="footer-link-contact">Contact</a>
        </nav>

        <div className="footer-social">
          <a href="#" className="social-link" aria-label="Instagram" data-testid="social-instagram">
            <Instagram size={18} />
          </a>
          <a href="#" className="social-link" aria-label="LinkedIn" data-testid="social-linkedin">
            <Linkedin size={18} />
          </a>
          <a href="mailto:partner@experienceinterlude.com" className="social-link" aria-label="Email" data-testid="social-email">
            <Mail size={18} />
          </a>
        </div>

        <p className="footer-copyright">&copy; 2025 INTERLUDE. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
